import { type RefObject, useCallback, useLayoutEffect, useState } from 'react';

import { useResizeObserver } from '../useResizeObserver';

// Tracks an element's rendered height, re-measuring on the element's own resize

export const useElementHeight = (
  ref: RefObject<HTMLElement | null>,
): number => {
  const [height, setHeight] = useState(0);

  const updateHeight = useCallback(() => {
    const element = ref.current;
    if (element) {
      setHeight(Math.round(element.getBoundingClientRect().height));
    }
  }, [ref]);

  useLayoutEffect(() => {
    updateHeight();
  }, [updateHeight]);

  const attachResizeObserver = useResizeObserver({ onResize: updateHeight });

  useLayoutEffect(() => {
    attachResizeObserver(ref.current);
    return () => attachResizeObserver(null);
  }, [ref, attachResizeObserver]);

  return height;
};
